<template>
  <div class="UserMessage">

    <!--span class="time">
      {{time}}
    </span-->

    <div v-if="!(userMessage.notice && transcriptSettings.captionsOnly)">

      <span v-if="!(userMessage.notice || transcriptSettings.captionsOnly)" class="user">
        {{user.name}}
        <br />
      </span>

      <span class="message" :class="{'notice': userMessage.notice}">
        {{message}}
      </span>

    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ComponentTemplate',
  components: {
    //Component
  },
  data: function () {
    return {
      //name: "name"
    }
  },
  props: {
    userMessage: Object
  },
  computed: {
    ...mapState('room',[
      'transcriptSettings'
    ]),
    user: function () {
      return this.userMessage.user
    },
    time: function () {
      return new Date(this.userMessage.time).toLocaleTimeString()
    },
    message: function () {
      return this.userMessage.message
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.UserMessage{
  line-height: 1.1em;
}

.time, .user{
  opacity: 0.5;
  font-size: smaller;
}

.user {
  font-weight: bold;
}

.notice{
  opacity: 0.75;
  font-size: smaller;
}

</style>
